module.exports = __webpack_public_path__ + "static/img/Kanada.9e776d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/landmark/Kanada.png
// module id = zJ+4
// module chunks = 1